import React, { useContext, useEffect, useState } from "react";
import { Paper } from "@mui/material";
import { TableContainer } from "@mui/material";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { IBalanco } from "../../../Interfaces/eficiencia_alimentar/cc_caderno_campo";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { func_print } from "../../../Func_genericas/func_print";
import { get } from "../../../Services/tokenConfig";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { meses_ano } from "../../../Func_genericas/valores_estaticos";

interface IJaneiroGH1Props {
  idCabecalho: number | undefined;
  rows_balanco: IBalanco | undefined;
  set_rows_balanco: React.Dispatch<React.SetStateAction<IBalanco | undefined>>;
}

export const TabelaBalancoGH1: React.FC<IJaneiroGH1Props> = ({
  idCabecalho,
  rows_balanco,
  set_rows_balanco
}) => {
  const auth = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const order = Object.fromEntries(meses_ano.map((k, i) => [k, i + 1]));

  async function getOperacoesBalanco() {
    try {
      if (idCabecalho !== undefined && idCabecalho !== 0) {
        let res = await get(auth.token.cookie_token, `/get_balanco_id_tipo_alimento/${idCabecalho}`);
        if (res.status === 200) {
          if (res.data.result.length === 0) {

            set_rows_balanco(undefined)

          } else {

            const order = Object.fromEntries(meses_ano.map((k, i) => [k, i + 1]));

            res.data.result[0].balancos_um.sort((a: any, b: any) =>
              (order[a.mes] || Number.MAX_VALUE) - (order[b.mes] || Number.MAX_VALUE)
            );
            set_rows_balanco(res.data.result[0]);

          }
        }

      };
      setIsLoading(false);
    } catch (error) {
      func_print("getOperacoesBalanco", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getOperacoesBalanco();
    })();
  }, [idCabecalho]);

  return (
    <CustomThemeProvider>
      {isLoading ?
        <LoadingVulpes /> :
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <table width="100%">
            <div style={{
              display: "flex",
              flex: 1,

            }}>
              <div style={{
                display: 'flex',
                flex: 0.2,
                alignItems: 'center',
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                fontWeight: "bold",
              }}></div>

              <div style={{
                display: 'flex',
                flex: 0.6,
                alignItems: 'center',
                flexDirection: 'column',
                fontSize: 12,
                fontWeight: "bold",

              }}>
                <div style={{
                  alignItems: "center",
                  justifyContent: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  border: `1px solid black`,
                  margin: 1,
                  width: '100%',
                  height: '100%'
                }}>
                  <div>Tipo de alimento</div>
                  <div>(kg x nº animais)</div>
                </div>
                <div style={{
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  display: 'flex',
                  flexDirection: 'row',
                  // backgroundColor:'red',
                  width: '100%',


                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "center",
                    justifyContent: "center",
                    margin: 1,
                    height: 40,


                    border: `1px solid black`,
                  }}>Pastagem</div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    margin: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    border: `1px solid black`,
                    height: 40,

                  }}>Silagem</div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    margin: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    border: `1px solid black`,
                    height: 40,

                  }}>Outra Forragem</div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    margin: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    border: `1px solid black`,
                    height: 40,

                  }}>Composto</div>
                </div>


              </div>
              <div style={{
                display: 'flex',
                flex: 0.2,
                alignItems: 'center',
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                fontWeight: "bold",
              }}>Anexar Rótulo Alimento Composto</div>

            </div>

            <div style={{
              display: "flex",
              flex: 1,

            }}>
              <div style={{
                display: 'flex',
                flex: 0.2,
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                flexDirection: 'column',
                // fontWeight: "bold",,
              }}>
                <div style={{
                  padding: 1,
                  fontSize: 12,
                  fontWeight: "bold",

                }}>
                  1. Necessidades alimentares anuais (PA)
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: "flex-end",
                  padding: 1

                }}>
                  Total de MS


                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: "flex-end",
                  padding: 1

                }}>
                  Peso na dieta (%)


                </div>
              </div>

              <div style={{
                display: 'flex',
                flex: 0.6,
                alignItems: 'center',
                flexDirection: 'column',
                fontSize: 12,

              }}>

                <div style={{
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  display: 'flex',
                  flexDirection: 'row',
                  // backgroundColor:'red',
                  width: '100%',
                  height: '100%',


                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_anuais_Pastagem === 0 ? 0 : rows_balanco?.necessidades_alimentares_anuais_Pastagem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_per_anuais_Pastagem === 0 ? 0 : rows_balanco?.necessidades_alimentares_per_anuais_Pastagem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_anuais_Silagem === 0 ? 0 : rows_balanco?.necessidades_alimentares_anuais_Silagem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_per_anuais_Silagem === 0 ? 0 : rows_balanco?.necessidades_alimentares_per_anuais_Silagem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_anuais_Outra_Ferragem === 0 ? 0 : rows_balanco?.necessidades_alimentares_anuais_Outra_Ferragem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_per_anuais_Outra_Ferragem === 0 ? 0 : rows_balanco?.necessidades_alimentares_per_anuais_Outra_Ferragem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_anuais_Composto === 0 ? 0 : rows_balanco?.necessidades_alimentares_anuais_Composto.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.necessidades_alimentares_per_anuais_Composto === 0 ? 0 : rows_balanco?.necessidades_alimentares_per_anuais_Composto.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                </div>


              </div>
              <div style={{
                display: 'flex',
                flex: 0.2,
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                flexDirection: 'column',
                // fontWeight: "bold",,
              }}>


              </div>


            </div>

            <div style={{
              display: "flex",
              flex: 1,

            }}>
              <div style={{
                display: 'flex',
                flex: 0.2,
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                flexDirection: 'column',
                // fontWeight: "bold",,
              }}>
                <div style={{
                  padding: 1,
                  fontSize: 12,
                  fontWeight: "bold",

                }}>
                  2. Alimentação (Caderno de Campo)

                </div>

                {rows_balanco?.balancos_um === undefined ? <></> :
                  rows_balanco?.balancos_um.sort((a: any, b: any) =>
                    (order[a.mes] || Number.MAX_VALUE) - (order[b.mes] || Number.MAX_VALUE)
                  ).map((el, key) => {
                    return (<div key={key} style={{

                      padding: 1
                    }}>
                      {el.mes}


                    </div>)
                  })}


                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: "flex-end",
                  padding: 1

                }}>
                  Total de MS


                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: "flex-end",
                  padding: 1

                }}>
                  Peso na dieta (%)


                </div>
              </div>

              <div style={{
                display: 'flex',
                flex: 0.6,
                alignItems: 'center',
                flexDirection: 'column',
                fontSize: 12,

              }}>



                <div style={{
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  display: 'flex',
                  flexDirection: 'row',
                  // backgroundColor:'red',
                  width: '100%',
                  height: '100%',
                  margin: 1,

                }}>



                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    {rows_balanco?.balancos_um === undefined ? <></> :
                      rows_balanco?.balancos_um.sort((a: any, b: any) =>
                        (order[a.mes] || Number.MAX_VALUE) - (order[b.mes] || Number.MAX_VALUE)
                      ).map((el, key) => {
                        return (<div key={key} style={{

                          padding: 1
                        }}>
                          {el.alimentacao_Pastagem === 0 ? 0 : el.alimentacao_Pastagem.toFixed(3).toString().replace('.', ',')}
                        </div>)
                      })}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_Pastagem === 0 ? 0 : rows_balanco?.diferenca_total_MS_Pastagem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_per_Pastagem === 0 ? 0 : rows_balanco?.diferenca_total_MS_per_Pastagem.toFixed(3).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    {rows_balanco?.balancos_um === undefined ? <></> :
                      rows_balanco?.balancos_um.sort((a: any, b: any) =>
                        (order[a.mes] || Number.MAX_VALUE) - (order[b.mes] || Number.MAX_VALUE)
                      ).map((el, key) => {
                        return (<div key={key} style={{

                          padding: 1
                        }}>
                          {el.alimentacao_Silagem === 0 ? 0 : el.alimentacao_Silagem.toFixed(3).toString().replace('.', ',')}
                        </div>)
                      })}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_Silagem === 0 ? 0 : rows_balanco?.diferenca_total_MS_Silagem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_per_Silagem === 0 ? 0 : rows_balanco?.diferenca_total_MS_per_Silagem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    {rows_balanco?.balancos_um === undefined ? <></> :
                      rows_balanco?.balancos_um.sort((a: any, b: any) =>
                        (order[a.mes] || Number.MAX_VALUE) - (order[b.mes] || Number.MAX_VALUE)
                      ).map((el, key) => {
                        return (<div key={key} style={{

                          padding: 1
                        }}>
                          {el.alimentacao_outra_forragem === 0 ? 0 : el.alimentacao_outra_forragem.toFixed(3).toString().replace('.', ',')}
                        </div>)
                      })}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_outra_forragem === 0 ? 0 : rows_balanco?.diferenca_total_MS_outra_forragem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_per_outra_forragem === 0 ? 0 : rows_balanco?.diferenca_total_MS_per_outra_forragem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    {rows_balanco?.balancos_um === undefined ? <></> :
                      rows_balanco?.balancos_um.sort((a: any, b: any) =>
                        (order[a.mes] || Number.MAX_VALUE) - (order[b.mes] || Number.MAX_VALUE)
                      ).map((el, key) => {
                        return (<div key={key} style={{

                          padding: 1
                        }}>
                          {el.alimentacao_composto === 0 ? 0 : el.alimentacao_composto.toFixed(3).toString().replace('.', ',')}
                        </div>)
                      })}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_composto === 0 ? 0 : rows_balanco?.diferenca_total_MS_composto.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_total_MS_per_composto === 0 ? 0 : rows_balanco?.diferenca_total_MS_per_composto.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                </div>


              </div>
              <div style={{
                display: 'flex',
                flex: 0.2,
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                flexDirection: 'column',
                // fontWeight: "bold",,
              }}>


              </div>
            </div>
            <div style={{
              display: "flex",
              flex: 1,

            }}>
              <div style={{
                display: 'flex',
                flex: 0.2,
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                flexDirection: 'column',
                // fontWeight: "bold",,
              }}>
                <div style={{
                  padding: 1,
                  fontSize: 12,
                  fontWeight: "bold",

                }}>
                  3. Diferença (2-1)

                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: "flex-end",
                  padding: 1

                }}>
                  Total de MS


                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: "flex-end",
                  padding: 1

                }}>
                  Peso na dieta (%)


                </div>
              </div>

              <div style={{
                display: 'flex',
                flex: 0.6,
                alignItems: 'center',
                flexDirection: 'column',
                fontSize: 12,

              }}>

                <div style={{
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  display: 'flex',
                  flexDirection: 'row',
                  // backgroundColor:'red',
                  width: '100%',
                  height: '100%',
                  margin: 1,


                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_Pastagem === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_Pastagem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_per_Pastagem === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_per_Pastagem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_Silagem === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_Silagem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_per_Silagem === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_per_Silagem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_outra_forragem === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_outra_forragem.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_per_outra_forragem === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_per_outra_forragem.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    margin: 1,
                    flexDirection: "column",

                    // height: 40,

                    height: '100%',

                    border: `1px solid black`,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_composto === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_composto.toFixed(3).toString().replace('.', ',')}
                    </div>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: "flex-end",
                      padding: 1

                    }}>
                      {rows_balanco?.diferenca_Peso_dieta_per_composto === 0 ? 0 : rows_balanco?.diferenca_Peso_dieta_per_composto.toFixed(0).toString().replace('.', ',')}%
                    </div>
                  </div>
                </div>


              </div>
              <div style={{
                display: 'flex',
                flex: 0.2,
                justifyContent: "center",
                border: `1px solid black`,
                margin: 1,
                fontSize: 12,
                flexDirection: 'column',
                // fontWeight: "bold",,
              }}>


              </div>
            </div>

          </table>
        </TableContainer>
      }
    </CustomThemeProvider>
  );
};
